import apiClient from '../api/apiClient';

const INVESTOR_ADMIN_BASE = '/api/v1/admin/investors';
const buildUrl = (investorId) => `${INVESTOR_ADMIN_BASE}/${investorId}/profile`;

const getSection = async (investorId, section) => {
  const response = await apiClient.get(buildUrl(investorId), {
    params: { section },
  });
  return response?.data?.data || {};
};

const investorProfileService = {
  /** Bank + demat sections for order placement wizard. */
  getBankAndDematForOrder: (investorId) =>
    getSection(investorId, 'bank_details,demat_details'),
  getPortfolio: (investorId) => getSection(investorId, 'portfolio,pre_ipo_transactions'),
  getPersonalInfo: (investorId) => getSection(investorId, 'personal_info'),
  getBankDetails: (investorId) => getSection(investorId, 'bank_details'),
  getDematDetails: (investorId) => getSection(investorId, 'demat_details'),
  getAddress: (investorId) => getSection(investorId, 'address'),
  getProfessionalDetails: (investorId) => getSection(investorId, 'professional_details'),
  getNominee: (investorId) => getSection(investorId, 'nominee'),
  getPreIpoTransactionsAll: (investorId) => getSection(investorId, 'pre_ipo_transactions_all'),

  addBankAccount: async (investorUuid, payload) => {
    const response = await apiClient.post(`${INVESTOR_ADMIN_BASE}/${investorUuid}/bank-accounts`, payload);
    return response.data;
  },

  setPrimaryBankAccount: async (investorUuid, bankUuid) => {
    const response = await apiClient.patch(
      `${INVESTOR_ADMIN_BASE}/${investorUuid}/bank-accounts/${bankUuid}/set-primary`
    );
    return response.data;
  },

  deleteBankAccount: async (investorUuid, bankUuid) => {
    const response = await apiClient.delete(
      `${INVESTOR_ADMIN_BASE}/${investorUuid}/bank-accounts/${bankUuid}`
    );
    return response.data;
  },

  getBankMismatchPendingReview: async (investorUuid) => {
    const response = await apiClient.get(
      `${INVESTOR_ADMIN_BASE}/${investorUuid}/bank-mismatch/pending-review`
    );
    return response?.data?.data ?? response?.data ?? {};
  },

  verifyBankMismatchDocument: async (investorUuid, documentId, status) => {
    const response = await apiClient.patch(
      `${INVESTOR_ADMIN_BASE}/${investorUuid}/documents/${encodeURIComponent(documentId)}/verify`,
      { status }
    );
    return response.data;
  },

  uploadBankMismatchCheque: async (investorUuid, formData) => {
    const response = await apiClient.post(
      `${INVESTOR_ADMIN_BASE}/${investorUuid}/bank-mismatch-cheque`,
      formData,
      {
        transformRequest: [
          (data, headers) => {
            if (typeof FormData !== 'undefined' && data instanceof FormData) {
              if (headers?.delete) headers.delete('Content-Type');
              else if (headers) {
                delete headers['Content-Type'];
                delete headers['content-type'];
              }
            }
            return data;
          },
        ],
      }
    );
    return response.data;
  },

  updateBasicProfile: async (investorId, payload) => {
    const response = await apiClient.patch(`${INVESTOR_ADMIN_BASE}/${investorId}/basic-profile`, payload);
    return response.data;
  },

  uploadDematCmr: async (investorId, formData) => {
    const response = await apiClient.post(`${INVESTOR_ADMIN_BASE}/${investorId}/demat/upload-cmr`, formData, {
      transformRequest: [
        (data, headers) => {
          if (typeof FormData !== 'undefined' && data instanceof FormData) {
            if (headers?.delete) headers.delete('Content-Type');
            else if (headers) {
              delete headers['Content-Type'];
              delete headers['content-type'];
            }
          }
          return data;
        },
      ],
    });
    return response.data;
  },

  editDematAccount: async (investorUuid, dematUuid, payload) => {
    const response = await apiClient.patch(
      `${INVESTOR_ADMIN_BASE}/${investorUuid}/demat-accounts/${dematUuid}`,
      payload
    );
    return response.data;
  },

  verifyDematAccount: async (investorUuid, dematUuid) => {
    const response = await apiClient.post(
      `${INVESTOR_ADMIN_BASE}/${investorUuid}/demat-accounts/${dematUuid}/verify`
    );
    return response.data;
  },
};

export default investorProfileService;
